'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWrapperStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  fullWindowSize: _propTypes2.default.bool,
  scrollable: _propTypes2.default.bool,
  hasTransparentBg: _propTypes2.default.bool,
  hasRegionAside: _propTypes2.default.bool,
  regionAsideMaxWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  regionAsideShow: _propTypes2.default.bool,
  customMinWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  theme: _propTypes2.default.object
};
var defaultProps = {
  fullWindowSize: false,
  scrollable: false,
  hasTransparentBg: false,
  hasRegionAside: false,
  regionAsideMaxWidth: 150,
  regionAsideShow: false,
  customMinWidth: 0
};
var boxShadow3 = (0, _reactackleCore.boxShadow)(3);
/** Prop Receivers */

var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme,
      fullWindowSize = _ref.fullWindowSize,
      scrollable = _ref.scrollable,
      hasTransparentBg = _ref.hasTransparentBg;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.dialog.window,
      zIndex = _theme$reactackle$com.zIndex,
      backgroundColor = _theme$reactackle$com.backgroundColor,
      margin = _theme$reactackle$com.margin,
      borderRadius = _theme$reactackle$com.borderRadius;
  var dialogBgColor = hasTransparentBg ? 'transparent' : backgroundColor,
      dialogBorderRadius = hasTransparentBg ? '0' : (0, _reactackleCore.getValueString)(borderRadius);
  return (0, _styledComponents.css)(['z-index:', ';background-color:', ';max-height:calc(100vh - ', ' * 2);border-radius:', ';animation:', ' 300ms ease-in;', ' ', ''], zIndex, dialogBgColor, (0, _reactackleCore.getValueString)(margin), (0, _reactackleCore.getValueString)(dialogBorderRadius), _reactackleCore.animations.fadeIn, scrollable && 'max-height: 100%;', fullWindowSize && '\n      max-width: 100vw;\n      width: 100%;\n      height: 100%;\n      flex-grow: 1;\n    ');
};
/** Styles */


var ContentWrapperStyled = exports.ContentWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ContentWrapperStyled'
})(['position:relative;margin:auto;display:flex;width:100%;', ';', ';'], baseProps, boxShadow3);

ContentWrapperStyled.propTypes = propTypes;
ContentWrapperStyled.defaultProps = defaultProps;
ContentWrapperStyled.displayName = 'ContentWrapperStyled';